/**
 * Service Selection Functions
 * Handles direct service selection from button clicks
 */

export function initServiceSelection() {
  window.selectServiceDirect = function(serviceKey) {
    console.log('Service selected:', serviceKey);
    window.currentServiceKey = serviceKey;

    // Function to update adminApp when it's ready
    const updateAdminApp = () => {
      if (window.adminApp) {
        window.adminApp.currentServiceKey = serviceKey;
        console.log('Set adminApp.currentServiceKey to:', serviceKey);

        // Also call selectService on adminApp to ensure proper initialization
        if (typeof window.adminApp.selectService === 'function') {
          window.adminApp.selectService(serviceKey);
        }
        return true;
      }
      return false;
    };

    // Try to update adminApp immediately
    if (!updateAdminApp()) {
      // If not ready, retry after a short delay
      setTimeout(updateAdminApp, 100);
      setTimeout(updateAdminApp, 500);
    }

    // Show customer selection section (NEW UX)
    const customerSection = document.getElementById('customerSelectionSection');
    if (customerSection) {
      customerSection.style.display = 'block';

      // Scroll to customer selection
      setTimeout(() => {
        customerSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }

    // Update charge summary
    if (window.updateChargeSummary) {
      window.updateChargeSummary();
    }

    // Update minimum fee checkbox visibility
    if (window.updateMinimumFeeCheckbox) {
      window.updateMinimumFeeCheckbox(serviceKey);
    }
  };

  // Display selected service with "Change Service" button
  window.displaySelectedService = function(service) {
    const container = document.getElementById('serviceSelectionContainer');
    const display = document.getElementById('selectedServiceDisplay');
    const optionsPanel = document.getElementById('serviceOptionsPanel');

    if (!container || !display) {
      console.warn('Service selection container elements not found');
      return;
    }

    // Show service name
    const serviceName = service.service_name || service.service_type.replace(/_/g, ' ');
    display.textContent = serviceName;

    // Make container visible
    container.style.display = 'block';

    // Hide options panel initially
    if (optionsPanel) {
      optionsPanel.style.display = 'none';
    }

    console.log('✅ Displayed selected service:', serviceName);
  };

  // Toggle service options panel
  window.showServiceOptions = function() {
    const optionsPanel = document.getElementById('serviceOptionsPanel');
    if (optionsPanel) {
      optionsPanel.style.display = optionsPanel.style.display === 'none' ? 'block' : 'none';
    }
  };

  // Show service selection buttons for manual selection
  window.showServiceSelectionButtons = function() {
    const container = document.getElementById('serviceSelectionContainer');
    const optionsPanel = document.getElementById('serviceOptionsPanel');

    if (container) {
      container.style.display = 'block';
    }

    if (optionsPanel) {
      optionsPanel.style.display = 'block';
    }

    console.log('✅ Showing service selection buttons for manual selection');
  };

  console.log('✅ Service selection functions initialized');
}
